import React, { useEffect } from "react";

const ConnectSocket = ({ wsConnect, wsConnected, user, wsDisconnect }) => {
	const connectWS = () => {
		if (navigator.userAgent.indexOf("Firefox") === -1 && !wsConnected(`${process.env.REACT_APP_WS_URL}/${user.session.id}`))
			wsConnect(`${process.env.REACT_APP_WS_URL}/${user.session.id}`);
	};
	useEffect(() => {
		connectWS();
		return () => {
			wsDisconnect();
		};
	}, []);

	return <></>;
};
export default ConnectSocket;
